import { render, staticRenderFns } from "./gg-category-url-table.vue?vue&type=template&id=3886654e&"
import script from "./gg-category-url-table.vue?vue&type=script&lang=js&"
export * from "./gg-category-url-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports